import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { LineChartModule as NgxLineChartModule } from '@swimlane/ngx-charts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LineChartComponent } from './line.component';
import { LineMapperService } from './services/line.mapper.service';

@NgModule({
  declarations: [
    LineChartComponent
  ],
  imports: [
    NgxLineChartModule,
    FlexLayoutModule,
    FuseSharedModule,
    MatProgressSpinnerModule,
    FuseWidgetModule,
    NgxSkeletonLoaderModule,
    TranslateModule
  ],
  exports: [
    LineChartComponent
  ],
  providers: [
    LineMapperService
  ]
})
export class LineChartModule {}
